import { createSlice } from "@reduxjs/toolkit";

export const emisorSlices = createSlice({
  name: "emisor",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = emisorSlices.actions;

export default emisorSlices.reducer;
